import { dispatch } from "../store/store";
import {
  addCompanyDocumentData,
  setIsCompanyDocumentLoadingData,
  getCompanyDocumentsByCompanyIdData,
  addCompanyFolderData,
  renameCompanyFolderData,
  getCompanyFoldersByCompanyIdData,
  viewCompanyDocumentData,
  getDocumentsAnalyticsByCompanyIdData,
  getDocumentsMembersCompliancesByCompanyIdData,
  getDocumentsOverallCompliancesByCompanyIdData,
  getCompayDocumentByIdData,
  updateCompanyDocumentData,
  deleteCompanyDocumentsData,
  getCompanyDocumentsByCompanyIdAndEmailData,
} from "@/features/companyDocumentSlice/companyDocumentSlice";
import { logErrorWithPayload } from "../services/logService";
import { getAllCompanyDocumentsByCompanyIdData } from "../features/companyDocumentSlice/companyDocumentSlice";

const reducerName = "companyDocuments";

// #region State Setters
export const setIsCompanyDocumentLoading = (isLoading) => {
  dispatch(setIsCompanyDocumentLoadingData(isLoading));
};
// #endregion

// #region API getter/caller functions for components usage to dispatch REDUX extra reducers

export const addCompanyDocument = async (data) => {
  let result = null;
  try {
    result = await dispatch(addCompanyDocumentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getCompanyDocumentsByCompanyId = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(
      getCompanyDocumentsByCompanyIdData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getCompanyDocumentsByCompanyIdAndEmail = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(
      getCompanyDocumentsByCompanyIdAndEmailData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const addCompanyFolder = async (data) => {
  let result = null;
  try {
    result = await dispatch(addCompanyFolderData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const renameCompanyFolder = async (data) => {
  let result = null;
  try {
    result = await dispatch(renameCompanyFolderData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getCompanyFolders = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(
      getCompanyFoldersByCompanyIdData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getDocumentsAnalyticsByCompanyId = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(
      getDocumentsAnalyticsByCompanyIdData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const viewCompanyDocument = async (data) => {
  let result = null;
  try {
    result = await dispatch(viewCompanyDocumentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getDocumentsOverallCompliancesByCompanyId = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(
      getDocumentsOverallCompliancesByCompanyIdData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getDocumentsMembersCompliancesByCompanyId = async (companyID) => {
  let result = null;
  try {
    result = await dispatch(
      getDocumentsMembersCompliancesByCompanyIdData(companyID),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const getCompanyDocumentById = async (docId) => {
  let result = null;
  try {
    result = await dispatch(getCompayDocumentByIdData(docId)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const updateCompanyDocument = async (data) => {
  let result = null;
  try {
    result = await dispatch(updateCompanyDocumentData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};
export const getAllCompanyDocumentsByCompanyId = async (data) => {
  let result = null;
  try {
    result = await dispatch(
      getAllCompanyDocumentsByCompanyIdData(data),
    ).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

export const deleteCompanyDocuments = async (data) => {
  let result = null;
  try {
    result = await dispatch(deleteCompanyDocumentsData(data)).unwrap();
  } catch (error) {
    logErrorWithPayload(error);
    result = null;
  }
  return result;
};

// #endregion
